import { canAddService } from "../../domain/influencerService";

// A service from a selected service's exclusion group is withheld because the
// server rejects it with a 409.
export const addableServicesFor = (
  availableServices = [],
  selectedServices = [],
) =>
  availableServices.filter(
    (service) => service.isActive && canAddService(service, selectedServices),
  );

export const editableSections = ({
  cartProduct,
  addedAddons = [],
  unaddedAddons = [],
  availableServices = [],
}) => {
  const selectedServices = cartProduct?.services ?? [];
  const addableServices = addableServicesFor(
    availableServices,
    selectedServices,
  );

  const hasPersonalization = Boolean(cartProduct?.isPersonalized);
  const hasAddons = addedAddons.length > 0 || unaddedAddons.length > 0;
  const hasServices = selectedServices.length > 0 || addableServices.length > 0;

  return {
    addableServices,
    hasPersonalization,
    hasAddons,
    hasServices,
    hasAnything: hasPersonalization || hasAddons || hasServices,
  };
};

export const deepLinkProducts = (sectionsByCartProductId, cartProducts) =>
  cartProducts
    .filter(
      ({ cartProductId }) =>
        sectionsByCartProductId[cartProductId]?.hasAnything,
    )
    .map(({ cartProductId }) => cartProductId);

export default editableSections;
